/* unplugin-vue-components disabled */import { render } from "./ComplaintInfo.vue?vue&type=template&id=13ea9424&scoped=true&ts=true"
import script from "./ComplaintInfo.vue?vue&type=script&lang=ts"
export * from "./ComplaintInfo.vue?vue&type=script&lang=ts"

import "./ComplaintInfo.vue?vue&type=style&index=0&id=13ea9424&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ea9424"]])

export default __exports__